const highlightClassName = 'adi-rainbow-nav-highlight';
const styleElementId = 'adi-rainbow-nav-styles';
let highlightTimer = null;

const highlightCss = `
#body-scroll.${highlightClassName} {
  position: relative;
}
#body-scroll.${highlightClassName}::after {
  content: '';
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  pointer-events: none;
  z-index: 45;
  border: 3px solid transparent;
  border-radius: 4px;
  background: linear-gradient(90deg, #ff6b6b, #feca57, #48dbfb, #1dd1a1, #5f27cd, #ff6b6b) border-box;
  -webkit-mask: linear-gradient(#fff 0 0) padding-box, linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  animation: adiRainbowShift 2.8s linear infinite;
  opacity: 0.85;
}
@keyframes adiRainbowShift {
  0% { filter: hue-rotate(0deg); }
  100% { filter: hue-rotate(360deg); }
}
`;

function ensureHighlightStyles() {
  if (typeof document === 'undefined') {
    return;
  }
  if (document.getElementById(styleElementId) !== null) {
    return;
  }
  const styleEl = document.createElement('style');
  styleEl.id = styleElementId;
  styleEl.textContent = highlightCss;
  if (document.head !== null) {
    document.head.appendChild(styleEl);
  }
}

export function applyAdiNavigationHighlight(durationMs) {
  if (typeof document === 'undefined') {
    return;
  }
  ensureHighlightStyles();
  const target = document.getElementById('body-scroll');
  if (target === null) {
    return;
  }
  target.classList.add(highlightClassName);
  if (highlightTimer !== null) {
    clearTimeout(highlightTimer);
    highlightTimer = null;
  }
  const resolvedDuration = typeof durationMs === 'number' && durationMs > 0 ? durationMs : 4000;
  highlightTimer = setTimeout(function() {
    target.classList.remove(highlightClassName);
    highlightTimer = null;
  }, resolvedDuration);
}

export function clearAdiNavigationHighlight() {
  if (typeof document === 'undefined') {
    return;
  }
  const target = document.getElementById('body-scroll');
  if (target !== null) {
    target.classList.remove(highlightClassName);
  }
  if (highlightTimer !== null) {
    clearTimeout(highlightTimer);
    highlightTimer = null;
  }
}
